module.exports = __webpack_public_path__ + "img/icon_sos_btn_bell_7.92fdfecb.png";